import React from 'react';
import { Element } from 'react-scroll';
import { Submenu } from '../components';

export default (props) => (

  <div className="Content EVerbal-Content">

  	<span className="Mob-Title"> <h3 className="red-txt"> Expressão Verbal </h3> </span>

    <h2> Diretrizes de <br/> comunicação </h2>

    <Submenu
      links={[
        { to: "diretriz-geral-de-comunicacao", title: "Diretriz geral de <br/> comunicação", offset: -200 },
        { to: "diretrizes-de-conteúdo-e-comportamento", title: "Diretrizes de conteúdo <br/> e comportamento", offset: -190 },
        { to: "diretrizes-de-expressao", title: "Diretrizes de <br/> expressão", offset: -80 },
        { to: "diretrizes-taticas", title: "Diretrizes <br/> táticas", offset: -150 }
      ]} />

    <Element name="diretriz-geral-de-comunicacao">
      <Element className="Block Red-Block">

      	<div className="Text-Wrapper Content-Ajust white-txt">
      		<h1> Diretriz geral <br/> de comunicação </h1>

      		<p> Síntese conceitual e inspiradora para as expressões da marca. É uma ideia central que ajuda a nortear todo o processo criativo de uma marca. </p>

      		<ul>
      			<li> <p> Confiar nas pessoas é o que gera resultado na Brasal. </p> </li>
      			<li> <p> Atender e superar expectativas é o resultado que entregamos para todos os públicos que se relacionam com a marca. </p> </li>
      			<li> <p> Fazer é tirar projetos do papel, executar planos, atingir metas, cumprir compromissos, empreender, inovar. </p> </li>
      			<li> <p> As pessoas são o meio e o fim de tudo o que fazemos. </p> </li>
      		</ul>

      	</div>

      </Element>

      <div className="Img-Wrapper Full">
      	<img src={require("../img/EVerbal/pessoas.jpg")}/>
      </div>
    </Element>

    <Element name="diretrizes-de-conteúdo-e-comportamento">
      <Element className="Block">
      	<div className="Text-Wrapper Content-Ajust">
      		<h1 className="red-txt"> Diretrizes de <br/> conteúdo e <br/> comportamento</h1>

      		<p> Orienta a postura e o comportamento de colaboradores e construtores da marca, direcionando o conteúdo de discursos e argumentos na comunicação das relações. </p>

      		<ul className="red-dot">
      			<li> <p> Postura com foco sempre no resultado final. </p> </li>
      			<li> <p> Tolerância zero com improvisos. </p> </li>
      			<li> <p> Entregar o que se prometeu preserva a confiança dos relacionamentos. </p> </li>
      			<li> <p> Cumprir sempre a palavra empenhada. </p> </li>
      		</ul>
      	</div>
      </Element>

      <div className="Img-Wrapper Full">
      	<img src={require("../img/EVerbal/compromisso.jpg")}/>
      </div>
    </Element>

    <Element name="diretrizes-de-expressao">
      <Element className="Block">
      	<div className="Text-Wrapper Content-Ajust">
      		<h1 className="red-txt"> Diretrizes de <br/> Expressão </h1>

      		<p> Trata-se de tangibilização das diretrizes para elaboração de textos, como tom de voz e definição de interlocutor. </p>

      		<ul className="red-dot">
      			<li> <p> Não existe dúvida nas afirmações da Brasal, porque existe certeza da entrega e do resultado. </p> </li>
      			<li> <p> Há uma assertividade terna, tranquila e sem arrogância no discurso. </p> </li>
      			<li> <p> Confiança em si mesmo, nas pessoas e no futuro está sempre presente nas mensagens da Brasal. </p> </li>
      			<li> <p> Expressões populares de bom tom são importantes recursos de retórica. </p> </li>
      			<li> <p> Interlocutor: NÓS ou A GENTE, dependendo do contexto e do nível de informalidade permitido pela peça de comunicação, para reforçar a proximidade. </p> </li>
      		</ul>
      	</div>
      </Element>

      <div className="Img-Wrapper Full">
      	<img src={require("../img/EVerbal/firme.jpg")}/>
      </div>
    </Element>

    <Element name="diretrizes-taticas" className="Block Red-Block">

    	<div className="Text-Wrapper Content-Ajust white-txt">
    		<h1> Diretrizes <br/> táticas </h1>

    		<p> Definem objetivos e mensagem-chave, à luz das diretrizes para cada público que será alvo da comunicação. </p>

    		<h4> Clientes </h4>

    		<span> Objetivos: </span>

    		<ul>
    			<li> <p> Incrementar valor de marca em cada segmento. </p> </li>
    			<li> <p> Apresentar uma unidade de comunicação. </p> </li>
    			<li> <p> Associar a marca aos atributos desejados com pertinência.  </p> </li>
    		</ul>

    		<span> mensagens-chave: </span>

    		<ul>
    			<li> <p> Brasal é segurança: de entrega, de realização, de cumprir compromissos e a palavra empenhada. </p> </li>
    			<li> <p> Brasal é qualidade: compromisso com a excelência de todos os seus produtos e serviços. </p> </li>
    		</ul>

    		<h4> parceiros </h4>

    		<span> Objetivos: </span>

    		<ul>
    			<li> <p> Fortalecer relacionamentos. </p> </li>
    			<li> <p> Aumentar valor percebido da parceria. </p> </li>
    			<li> <p> Aumentar valor de marca. </p> </li>
    		</ul>

    		<span> mensagens-chave: </span>

    		<ul>
    			<li> <p> Brasal cresce com seus parceiros, sempre realizando todos os processos com ética e excelência. </p> </li>
    			<li> <p> Se não for bom para o parceiro, não é bom para a Brasal. </p> </li>
    			<li> <p> Brasal sabe que preciso ter o olhar constante no futuro. </p> </li>
    		</ul>

    		<h4> colaboradores </h4>

    		<span> Objetivos: </span>

    		<ul>
    			<li> <p> Manter dedicação, engajamento e empenho. </p> </li>
    			<li> <p> Fazer as pessoas se sentirem valorizadas. </p> </li>
    			<li> <p> Estimular empreendedorismo e visão de futuro. </p> </li>
    		</ul>

    		<span> mensagens-chave: </span>

    		<ul>
    			<li> <p> Seu empenho e dedicação fazem da Brasal o que ela é. </p> </li>
    			<li> <p> Confiança é a base da relação entre pessoas e a Brasal. </p> </li>
    			<li> <p> Quando você empreende, a Brasal cresce junto. </p> </li>
    		</ul>


    	</div>

    </Element>

   </div>

);



// WEBPACK FOOTER //
// ./src/pages/ExpressaoVerbal.js